import { Icon } from '@/components/Icon';

/** Тот же паттерн, что пейджер в ClientsPage.tsx — только назад/вперёд, без номеров страниц. */
export function Pager({
  page,
  lastPage,
  onPageChange,
}: {
  page: number;
  lastPage: number;
  onPageChange: (page: number) => void;
}) {
  return (
    <div className="pager">
      <button
        type="button"
        disabled={page <= 1}
        onClick={() => onPageChange(page - 1)}
        aria-label="Предыдущая страница"
      >
        <Icon name="chevronLeft" size={14} />
      </button>
      <button
        type="button"
        disabled={page >= lastPage}
        onClick={() => onPageChange(page + 1)}
        aria-label="Следующая страница"
      >
        <Icon name="chevronRight" size={14} />
      </button>
    </div>
  );
}
